export default __webpack_public_path__ + "static/media/content.971ffa78.csv";